import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Badge, Button, Stack, Tooltip, Typography, useTheme } from '@mui/material';

export const SideNavButton = ({
  icon,
  label,
  isActive,
  onClick,
  onMouseOver,
  dataTestId,
  tooltip,
  badgeCount,
  imgUrl,
}) => {
  const theme = useTheme(); // Get the theme object

  // // Define active background color
  // const activeBgColor = theme.palette.mode !== 'dark' ? theme.palette.primary.main : theme.palette.primary.dark;
  // const hoverBgColor = isActive
  //   ? alpha(theme.palette.primary.dark, 0.6) // Slightly darker version of active color on hover
  //   : theme.palette.action.hover; // Standard hover color

  return (
    <Tooltip title={tooltip}>
      <Stack direction="column" alignItems="center" onClick={onClick} onMouseOver={onMouseOver} sx={{ width: '100%' }}>
        <Button
          disableElevation={true}
          variant={isActive ? 'contained' : 'text'}
          sx={{
            borderRadius: '24px',
            padding: '5px 0 5px 0',
            width: '100%',
            textAlign: 'center',
            boxSizing: 'content-box',
            boxShadow: 0,
            // backgroundColor: isActive ? theme.palette.primary.main : 'transparent',
            height: 24,
            color: isActive ? theme.palette.getContrastText(theme.palette.primary.main) : theme.palette.text.primary,
          }}
        >
          <Badge badgeContent={badgeCount} color="info">
            {icon && <FontAwesomeIcon icon={icon} style={{ height: '24px' }} size={'2x'} fixedWidth />}
            {imgUrl && <img src={imgUrl} alt={label} style={{ height: '2rem' }} />}
          </Badge>
        </Button>

        {label && <Typography variant="caption">{label}</Typography>}
      </Stack>
    </Tooltip>
  );
};
